// extracted by mini-css-extract-plugin
export default {"root":"FormLabel_root__c7KsP"};